import { requests, mainApiRoot } from './index'

export const SerpChecker = {
  get: payload => requests.post(mainApiRoot, '/serp-checker', payload),
  getPrevious: historyId => requests.get(mainApiRoot, `/serp-checker/history/${historyId}`),
  getHistory: () => requests.get(mainApiRoot, '/serp-checker/history'),
  del: historyId => requests.del(mainApiRoot, `/serp-checker/history/${historyId}`)
}
